import AgTechHeaderDetail from "../Headers/AgTechHeaderDetail";

export const MonthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export const DayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const AgTechDateHeader = (props: { date?: Date }) => {
    let currentDate = props.date ?? new Date();
    let currentMonth = MonthNames[currentDate.getMonth()];
    let currentDayOfWeek = DayNames[currentDate.getDay()];

    let currentDateDescription = `${currentMonth} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

    return (
        <div className="column-based-vertically-centered container">
            <div className='square-50 mr-4 font-size-emphasized font-semibold centered bordered rounded bg-white container'>
                {currentDate.getDate()}
            </div>
            <AgTechHeaderDetail
                header={currentDateDescription}
                detail={currentDayOfWeek}
                settings={{
                    header: {
                        classes: '!text-plus'
                    }
                }}
            />
        </div>
    )
}